import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CentrexCalendarModel } from '../models/centrex-calendar.model';
import { ApiService } from './api.service';
import { ServiceBase } from './service-base';

@Injectable({
  providedIn: 'root',
})
export class CentrexCalendarsService extends ServiceBase {
  constructor(private http: HttpClient, private apiService: ApiService) {
    super();
  }

  private createHeaders(additionalHeaders?: {
    [key: string]: string;
  }): HttpHeaders {
    const token = this.apiService.getAccessToken();
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    if (additionalHeaders) {
      Object.keys(additionalHeaders).forEach((key) => {
        headers = headers.set(key, additionalHeaders[key]);
      });
    }

    return headers;
  }

  private handleError(error: any): Observable<never> {
    console.error('Erreur CentrexCalendarsService', error);
    return throwError(() => error);
  }

  getCalendars(
    organizationId: string,
    platform: string
  ): Observable<CentrexCalendarModel[]> {
    const url = `${this.apiUrl}/api/centrex/calendars`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .get<CentrexCalendarModel[]>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  getCalendarById(
    organizationId: string,
    platform: string,
    calendarId: string
  ): Observable<CentrexCalendarModel> {
    const url = `${this.apiUrl}/api/centrex/calendars/${calendarId}`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .get<CentrexCalendarModel>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  createCalendar(
    organizationId: string,
    platform: string,
    calendar: CentrexCalendarModel
  ): Observable<CentrexCalendarModel> {
    const url = `${this.apiUrl}/api/centrex/calendars`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .post<CentrexCalendarModel>(url, calendar, { headers })
      .pipe(catchError(this.handleError));
  }

  updateCalendar(
    organizationId: string,
    platform: string,
    calendarId: string,
    calendar: CentrexCalendarModel
  ): Observable<CentrexCalendarModel> {
    const url = `${this.apiUrl}/api/centrex/calendars/${calendarId}`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .patch<CentrexCalendarModel>(url, calendar, { headers })
      .pipe(catchError(this.handleError));
  }

  deleteCalendar(
    organizationId: string,
    platform: string,
    calendarId: string
  ): Observable<void> {
    const url = `${this.apiUrl}/api/centrex/calendars/${calendarId}`;
    const headers = this.createHeaders({
      'X-OrganizationId': organizationId,
      'X-CentrexPlatform': platform,
    });

    return this.http
      .delete<void>(url, { headers })
      .pipe(catchError(this.handleError));
  }
}
